<template>
  <div>
    <b-card>
      <project-search
        :reset-search="resetSearch"
        :search-data="searchData"
      />
    </b-card>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Projeler</b-card-title>
        <b-button
          variant="primary"
          :to="'/app/projects/customer-search'"
        >
          <feather-icon icon="PlusIcon" />
          Talep Oluştur
        </b-button>
      </b-card-header>
      <b-table
        v-if="dataList.length > 0 "
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(title)="data">
          {{ data.item.title }}
          <div v-if="data.item.customers">
            <small class="text-warning">{{ data.item.customers }}</small>
          </div>
        </template>
        <template #cell(username)="data">
          {{ data.item.username }}
          <div v-if="data.item.created">
            <small class="text-primary"> {{ moment(data.item.created).format('DD.MM.YYYY') }}</small>
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <list-buttons
              primary-text="Görüntüle"
              :primary-action="'/app/projects/view/' + data.item.id"
              :edit-action="checkMarketingPermission(data.item)"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
        </template>
      </b-table>
      <b-alert
        v-else
        show
        variant="info"
        class="mr-2 ml-2"
      >
        <div class="alert-body text-center">
          <div class="lead">
            Proje kaydı bulunamadı.
          </div>
          <div class="mt-1">
            <b-button
              variant="info"
              size="sm"
              :to="'/app/projects/customer-search'"
            >
              Yeni Talebi Proje Oluştur
            </b-button>
          </div>
        </div>
      </b-alert>
      <b-card-footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BTable, BCard, BCardHeader, BCardTitle, BButton, BAlert, BPagination, BCardFooter,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProjectSearch from '@/views/Admin/Projects/Elements/Search.vue'

export default {
  name: 'Projects',
  components: {
    ProjectSearch,
    BCardFooter,
    BPagination,
    BAlert,
    ListButtons,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'pnumber',
          label: 'Proje Kodu',
        },
        {
          key: 'title',
          label: 'Ürün',
        },
        {
          key: 'status',
          label: 'Durum',
        },
        {
          key: 'username',
          label: 'Ekleyen',
        },
        {
          key: 'control',
          label: '',
          thClass: 'text-nowrap width-50',
        },
      ],
      dataQuery: {
        select: [
          'projects.id as id',
          'projects.title as title',
          'CONCAT(customers.cnumber,"-P",projects.pnumber) AS pnumber',
          'customers.company as customers',
          'project_statuses.title as status',
          'users.name as username',
          'projects.created as created',
        ],
        where: {
          'projects.id_project_statuses !=': 1,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
    search() {
      return this.$store.getters['projects/search']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getData()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('projects/getDataList', this.dataQuery)
    },
    searchData() {
      if (this.search.keyword) {
        this.dataQuery.or_like = {
          'customers.company': this.search.keyword,
          'customers.phone': this.search.keyword,
          'customers.cnumber': this.search.keyword,
          'customerCities.title': this.search.keyword,
          'projects.title': this.search.keyword,
          'projects.pnumber': this.search.keyword,
          'users.name': this.search.keyword,
        }
      }
      if (this.search.id_users) {
        this.dataQuery.where['projects.id_users'] = this.search.id_users
      } else if (this.dataQuery.where['projects.id_users']) {
        delete this.dataQuery.where['projects.id_users']
      }
      this.getData()
    },
    resetSearch() {
      this.dataQuery.or_like = {}
      this.search.keyword = null
      this.getData()
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projects/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
    checkMarketingPermission(project) {
      // kullanıcının pazarlamacı olduğunu sorgula
      if (this.userData.id_user_types === this.$store.state.app.ProjectMarketingUserTypeId) {
        // kullanıcı pazarlamacı ise yetkisi ile projeyi açanın yetkisini eşleştir
        if (this.userData.id === project.id_users) {
          // projeyi açan kişi pazarlamacı ve eşleşti ise yönlendir.
          return `/app/projects/edit/${project.id}`
        }
        // değil ise boş gönder
        return null
      }
      // kullanıcı pazaarlamacı değil ise adresi yazdır.
      return `/app/projects/edit/${project.id}`
    },
  },
}
</script>
